import { IconName } from '@infotech-soe/erp-ui-kit';
import { CommandHotKey, THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import {
  ConfirmationMessageType,
  UserInteractor,
  UserInteractorType,
} from '../UserInteractor';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

class DeleteRecordCommand extends CategoryCommand<void> {
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.DELETE,
    };
  }

  public getIcon(): IconName {
    return 'delete';
  }

  public getHotKey(): THotKey {
    return CommandHotKey.DeleteRecord;
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.CONFIRMATION,
      message: ConfirmationMessageType.DELETE,
    };
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.REMOVE;
  }

  public async getInitialArgs(): Promise<void> {
    // not implemented
  }
}

export default DeleteRecordCommand;
